import $axios from "../../api";
import axios from "axios"; // raw — untuk PUT langsung ke Spaces (tanpa interceptor/baseURL app)

// P26_018 Revamp PDP (FR-15) — Dashboard Video (simplified, no transcode).
const PREFIX = "website/video";

const state = () => ({
  isLoading: false,
  isErrors: "",
  isSuccess: false,
  page: 1,
  list: null,
  uploadProgress: 0,
  pickerList: [],
  pickerLoading: false,
  // Video yang sedang diedit — di-set saat klik "Edit" di list, dibaca halaman manage.
  current: null,
});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.isErrors = payload;
  },
  SET_IS_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_UPLOAD_PROGRESS(state, payload) {
    state.uploadProgress = payload;
  },
  SET_PICKER_LIST(state, payload) {
    state.pickerList = payload;
  },
  SET_PICKER_LOADING(state, payload) {
    state.pickerLoading = payload;
  },
  SET_CURRENT(state, payload) {
    state.current = payload;
  },
};

const actions = {
  getList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX}/list?page=${state.page}&view=${rootState.Main.view}${payload || ""}`)
        .then((res) => {
          commit("SET_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
        });
    });
  },
  // payload = FormData (video file + title + optional thumbnail base64)
  upload({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    commit("SET_UPLOAD_PROGRESS", 0);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/upload`, payload, {
          onUploadProgress: (e) => {
            if (e.total) {
              commit("SET_UPLOAD_PROGRESS", Math.round((e.loaded * 100) / e.total));
            }
          },
        })
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response?.data?.errors);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
        })
        .finally(() => {
          commit("SET_UPLOAD_PROGRESS", 0);
        });
    });
  },
  // Tahap 1 presigned: minta URL PUT ke server → kembalikan { upload_url, headers, filename, public_url }.
  presign({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/presign`, payload)
        .then((res) => resolve(res.data.data))
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  // Upload file LANGSUNG ke Spaces (browser → DigitalOcean), tidak lewat server app.
  uploadToSpaces({ commit }, { uploadUrl, file, headers }) {
    commit("SET_UPLOAD_PROGRESS", 0);
    // Instance axios BERSIH: buang header default app (X-Requested-With,
    // X-CSRF-TOKEN, Accept). Kalau ikut terkirim, preflight CORS Spaces minta
    // izin header itu → ditolak → PUT diblok. Spaces cuma izinkan content-type
    // & x-amz-acl.
    const s3 = axios.create();
    s3.defaults.headers.common = {};
    s3.defaults.headers.put = {};
    return s3
      .put(uploadUrl, file, {
        headers: headers || { "Content-Type": file.type || "video/mp4" },
        transformRequest: [(d) => d], // jangan diutak-atik axios (kirim file mentah)
        onUploadProgress: (e) => {
          if (e.total) commit("SET_UPLOAD_PROGRESS", Math.round((e.loaded * 100) / e.total));
        },
      })
      .finally(() => {
        commit("SET_UPLOAD_PROGRESS", 0);
      });
  },
  // Simpan metadata setelah file sudah di Spaces (tak ada file di request).
  storeMeta({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/store`, payload)
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
          resolve(res);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  update({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/update`, payload)
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
          resolve(res);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  showHide({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/showhide`, { id: payload })
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
        });
    });
  },
  // queryString built by the picker (find, brand_id[], category_id[], modes)
  pickerProducts({ commit, dispatch }, queryString) {
    commit("SET_PICKER_LOADING", true);
    return $axios
      .get(`${PREFIX}/picker-products?${queryString || ""}`)
      .then((res) => {
        commit("SET_PICKER_LIST", res.data.data);
      })
      .catch((error) => {
        dispatch("Main/globalSweetAlert", error.response, { root: true });
      })
      .finally(() => {
        commit("SET_PICKER_LOADING", false);
      });
  },
  syncProducts({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/sync-products`, payload)
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
          resolve(res);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
